import { render, staticRenderFns } from "./VersionButton.vue?vue&type=template&id=9aadc3c0&scoped=true"
import script from "./VersionButton.ts?vue&type=script&lang=ts&external"
export * from "./VersionButton.ts?vue&type=script&lang=ts&external"
import style0 from "./VersionButton.vue?vue&type=style&index=0&id=9aadc3c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aadc3c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aadc3c0')) {
      api.createRecord('9aadc3c0', component.options)
    } else {
      api.reload('9aadc3c0', component.options)
    }
    module.hot.accept("./VersionButton.vue?vue&type=template&id=9aadc3c0&scoped=true", function () {
      api.rerender('9aadc3c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Versioning/components/VersionButton/VersionButton.vue"
export default component.exports